export function notNill(value) {
    return !!value;
}
export function inverseObj(obj) {
    var retobj = {};
    for (var key in obj) {
        retobj[obj[key]] = key;
    }
    return retobj;
}
